import Vue from 'vue';

export default {
    storeCoverLetter(context, file) {
        const url = 'v1/me/files';
        const data = new FormData();
        data.append('type', 'cover_letter');
        data.append('file', file);
        return Vue.$axios.$post(url, data);
    },

    getCoverLetters() {
        const url = 'v1/me/files?type=cover_letter';
        return Vue.$axios.$get(url).then((response) => {
            return response;
        });
    },

    destroyCoverLetter(context, id) {
        const url = `v1/me/files/${id}`;
        return Vue.$axios.$delete(url);
    },

    downloadCoverLetter(context, uuid) {
        const url = `v1/download-file/${uuid}`;
        return Vue.$axios.get(url, {
            responseType: 'blob',
            timeout: 30000,
        });
    },

    createGuestCoverLetter(context, data) {
        const url = 'v1/guest-files';
        return Vue.$axios.$post(url, data);
    },

    getGuestCoverLetter(context, uuid) {
        const url = `v1/get-file/${uuid}`;
        return Vue.$axios.$get(url);
    },
};
